import { cn } from '@/lib/cn';
import { AppLogo } from './AppLogo';
import { NETWORKS, resolveNetwork } from './networks';

type NetworkLogoProps = {
  /** Network as the API spells it: "applovin", "facebook_ads", "unity_ads"… */
  network: string;
  size?: number;
  /** Set true when the network name is printed next to the logo. */
  decorative?: boolean;
  className?: string;
};

/**
 * Network identity as a logo on a white rounded tile — white in both themes
 * so dark marks stay visible in dark mode. The name is the alt text / title.
 */
export function NetworkLogo({ network, size = 24, decorative = false, className }: NetworkLogoProps) {
  const id = resolveNetwork(network);
  if (!id) return <AppLogo name={network} size={size} decorative={decorative} className={className} />;
  const { name, logo } = NETWORKS[id];
  return (
    <span
      title={name}
      style={{ width: size, height: size, padding: size >= 20 ? 3 : 1 }}
      className={cn('inline-grid shrink-0 place-items-center rounded-ctl border border-line bg-logo-tile align-middle', className)}
    >
      <img src={logo} alt={decorative ? '' : name} className="block size-full object-contain" />
    </span>
  );
}
